import React from 'react';
import {Stack, TablePagination, Typography} from '@mui/material';
import {DecorationGuidDto} from '../../../models/Decorations/IDecorationGuid';
import {ROWS_PER_PAGE_OPTIONS} from '../../../hooks/usePageLimit';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {DecorationInlineDetail, InlineRowShell, ListSort} from '../shared/InlineDetails';
import {useLocation, useNavigate} from 'react-router-dom';

interface Props {
    data: DecorationGuidDto[];
    totalCount: number;
    pageSize: number;
    currentPage: number;
    descending: boolean;
    orderByName: boolean;
    orderByPrice: boolean;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    onSortRequest: (id: 'name' | 'price', direction: 'asc' | 'desc') => void;
}

export const DecorationTable = ({
                                    data,
                                    totalCount,
                                    pageSize,
                                    currentPage,
                                    descending,
                                    orderByName,
                                    orderByPrice,
                                    onPageChange,
                                    onPageSizeChange,
                                    onSortRequest
                                }: Props) => {
    const {t} = useAppTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [expanded, setExpanded] = React.useState<string | null>(null);
    React.useEffect(() => {
        const state = location.state as { expandedId?: string; page?: number } | null;
        if (state?.page !== undefined) onPageChange(state.page);
        if (state?.expandedId !== undefined) setExpanded(state.expandedId);
        if (state) navigate(location.pathname, {replace: true, state: null});
    }, [location.pathname, location.state, navigate, onPageChange]);
    const active = 'name';
    const sort = () => onSortRequest('name', active === 'name' && !descending ? 'desc' : 'asc');
    return <><ListSort active={active} descending={descending} onChange={sort} includePrice={false}/><Stack
        spacing={0.75} sx={{p: {xs: .75, sm: 1.25}}}>{data.length === 0 ?
        <Typography align="center" color="text.secondary"
                    sx={{py: 3}}>{t('recipes:empty_list')}</Typography> : data.map(row => <InlineRowShell key={row.id}
                                                                                                          name={row.name}
                                                                                                          expanded={expanded === row.id}
                                                                                                          onToggle={() => setExpanded(expanded === row.id ? null : row.id ?? null)}><DecorationInlineDetail
            id={row.id ?? ''} returnPage={currentPage}/></InlineRowShell>)}</Stack><TablePagination
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS as unknown as number[]} component="div" count={totalCount}
        rowsPerPage={pageSize} page={currentPage} onPageChange={(_, next) => onPageChange(next)}
        onRowsPerPageChange={event => onPageSizeChange(parseInt(event.target.value, 10))}/></>;
};
